import React from "react";
import { useFormatter } from "../../../hooks/useFomatter";
import {
  IconFileText,
  IconCreditCard,
  IconReceipt,
  IconCoins,
  IconPlayerPause,
  IconCircleCheck,
} from "@tabler/icons";
import {
  Text,
  Badge,
  Stack,
  Paper,
  Group,
  SimpleGrid,
} from "@mantine/core";

const Payroll2Stat = ({ form, cols = 3, ...props }) => {
  const [formatter] = useFormatter();

  const {
    code,
    clientPayments,
    commissionStatements,
    pendingCount,
    totalPendingAmount,
    holdCount,
    totalHoldAmount,
    settledCount,
    totalSettledAmount,
  } = form.values;

  const clientPaymentsCount = clientPayments?.length || 0;
  const commissionStatementsCount = commissionStatements?.length || 0;

  const basicStats = [
    {
      icon: IconFileText,
      color: "#00b341",
      label: "Payroll Code",
      msg: code || "-",
    },
    {
      icon: IconCreditCard,
      color: "#40c057",
      label: "Client Payments",
      msg: clientPaymentsCount,
    },
    {
      icon: IconReceipt,
      color: "#40c057",
      label: "Comm. Statements",
      msg: commissionStatementsCount,
    },
  ];

  const statusStats = [
    {
      icon: IconCoins,
      color: "#868e96",
      label: "Pending",
      amount: totalPendingAmount || 0,
      count: pendingCount || 0,
      badgeColor: "gray",
    },
    {
      icon: IconPlayerPause,
      color: "#fd7e14",
      label: "Holding",
      amount: totalHoldAmount || 0,
      count: holdCount || 0,
      badgeColor: "orange",
    },
    {
      icon: IconCircleCheck,
      color: "#40c057",
      label: "Settled",
      amount: totalSettledAmount || 0,
      count: settledCount || 0,
      badgeColor: "green",
    },
  ];

  return (
    <Stack spacing="md" {...props}>
      <SimpleGrid
        cols={cols}
        breakpoints={[
          { maxWidth: "sm", cols: 1 },
          { maxWidth: "md", cols: 2 },
        ]}
      >
        {basicStats.map((stat, index) => (
          <Paper radius="md" p="md" key={index} shadow="md">
            <Group position="apart" noWrap>
              <stat.icon size={30} stroke={1} color={stat.color} />
              <div style={{ textAlign: "right" }}>
                <Text
                  color="dimmed"
                  size="xs"
                  transform="uppercase"
                  weight={700}
                >
                  {stat.label}
                </Text>
                <Text weight={700} size="xl">
                  {stat.msg}
                </Text>
              </div>
            </Group>
          </Paper>
        ))}
      </SimpleGrid>

      <SimpleGrid
        cols={cols}
        breakpoints={[
          { maxWidth: "sm", cols: 1 },
          { maxWidth: "md", cols: 2 },
        ]}
      >
        {statusStats.map((stat, index) => (
          <Paper radius="md" p="md" key={index} shadow="md">
            <Group position="apart" noWrap>
              <stat.icon size={30} stroke={1} color={stat.color} />
              <div style={{ textAlign: "right" }}>
                <Text
                  color="dimmed"
                  size="xs"
                  transform="uppercase"
                  weight={700}
                >
                  {stat.label}
                </Text>
                <Text weight={700} size="xl" color={stat.color}>
                  {formatter.currency(stat.amount)}
                </Text>
                <Badge size="sm" color={stat.badgeColor} variant="light">
                  {stat.count} bids
                </Badge>
              </div>
            </Group>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default Payroll2Stat;
